import { render, staticRenderFns } from "./FeaturesManagement.vue?vue&type=template&id=26f6f8f2&"
import script from "./FeaturesManagement.vue?vue&type=script&lang=ts&"
export * from "./FeaturesManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports